import { TextureDataDTO } from '../DTOs/TextureDataDTO';

export class TextureData {
  public static fromDTO(textureDataDTO: TextureDataDTO) {
    return new TextureData(
      textureDataDTO.textureUrl,
      textureDataDTO.bumpMapUrl,
      textureDataDTO.glossMapUrl,
      textureDataDTO.normalMapUrl,
      textureDataDTO.roughness,
      textureDataDTO.metalness,
      textureDataDTO.color,
      textureDataDTO.bumpScale,
      textureDataDTO.uvMapScale,
      textureDataDTO.normalMapScale,
      textureDataDTO.colorInfo,
      textureDataDTO.sheen,
      textureDataDTO.sheenColor,
      textureDataDTO.specularIntensity,
      textureDataDTO.specularColor,
      textureDataDTO.defaultColorId,
      textureDataDTO.ior,

      textureDataDTO.anisotropy,
      textureDataDTO.anisotropyRotation,
      textureDataDTO.attenuationColor,
      textureDataDTO.attenuationDistance,
      textureDataDTO.clearcoat,
      textureDataDTO.clearcoatRoughness,
      textureDataDTO.dispersion,
      textureDataDTO.reflectivity,
      textureDataDTO.iridescence,
      textureDataDTO.iridescenceIOR,
      textureDataDTO.thickness,
      textureDataDTO.transmission,

      textureDataDTO.thicknessMapUrl,
      textureDataDTO.specularIntensityMapUrl,
      textureDataDTO.sheenColorMapUrl,
      textureDataDTO.sheenRoughnessMapUrl,
      textureDataDTO.iridescenceThicknessMapUrl,
      textureDataDTO.iridescenceMapUrl,
      textureDataDTO.clearcoatRoughnessMapUrl,
      textureDataDTO.clearcoatNormalMapUrl,
      textureDataDTO.anisotropyMapUrl,
    );
  }

  private _textureUrl: string;
  private _bumpMapUrl?: string;
  private _glossMapUrl?: string;
  private _normalMapUrl?: string;
  private _roughness?: number;
  private _metalness?: number;
  private _color?: string;
  private _bumpScale?: number;
  private _uvMapScale?: number;
  private _normalMapScale?: number[];
  private _colorInfo?: string;
  private _sheen?: number;
  private _sheenColor?: string;
  private _specularIntensity?: number;
  private _specularColor?: string;
  private _defaultColorId?: string;
  private _ior?: number;

  // NEW private fields
  private _anisotropy?: number;
  private _anisotropyRotation?: number;
  private _attenuationColor?: string;
  private _attenuationDistance?: number;
  private _clearcoat?: number;
  private _clearcoatRoughness?: number;
  private _dispersion?: number;
  private _reflectivity?: number;
  private _iridescence?: number;
  private _iridescenceIOR?: number;
  private _thickness?: number;
  private _transmission?: number;

  private _thicknessMapUrl?: string;
  private _specularIntensityMapUrl?: string;
  private _sheenColorMapUrl?: string;
  private _sheenRoughnessMapUrl?: string;
  private _iridescenceThicknessMapUrl?: string;
  private _iridescenceMapUrl?: string;
  private _clearcoatRoughnessMapUrl?: string;
  private _clearcoatNormalMapUrl?: string;
  private _anisotropyMapUrl?: string;

  constructor(
    textureUrl: string,
    bumpMapUrl?: string,
    glossMapUrl?: string,
    normalMapUrl?: string,
    roughness?: number,
    metalness?: number,
    color?: string,
    bumpScale?: number,
    uvMapScale?: number,
    normalMapScale?: number[],
    colorInfo?: string,
    sheen?: number,
    sheenColor?: string,
    specularIntensity?: number,
    specularColor?: string,
    defaultColorId?: string,
    ior?: number,

    anisotropy?: number,
    anisotropyRotation?: number,
    attenuationColor?: string,
    attenuationDistance?: number,
    clearcoat?: number,
    clearcoatRoughness?: number,
    dispersion?: number,
    reflectivity?: number,
    iridescence?: number,
    iridescenceIOR?: number,
    thickness?: number,
    transmission?: number,

    thicknessMapUrl?: string,
    specularIntensityMapUrl?: string,
    sheenColorMapUrl?: string,
    sheenRoughnessMapUrl?: string,
    iridescenceThicknessMapUrl?: string,
    iridescenceMapUrl?: string,
    clearcoatRoughnessMapUrl?: string,
    clearcoatNormalMapUrl?: string,
    anisotropyMapUrl?: string,
  ) {
    this._textureUrl = textureUrl;
    this._bumpMapUrl = bumpMapUrl;
    this._glossMapUrl = glossMapUrl;
    this._normalMapUrl = normalMapUrl;
    this._roughness = roughness;
    this._metalness = metalness;
    this._color = color;
    this._bumpScale = bumpScale;
    this._uvMapScale = uvMapScale;
    this._normalMapScale = normalMapScale;
    this._colorInfo = colorInfo;
    this._sheen = sheen;
    this._sheenColor = sheenColor;
    this._specularIntensity = specularIntensity;
    this._specularColor = specularColor;
    this._defaultColorId = defaultColorId;
    this._ior = ior;

    // NEW assignments
    this._anisotropy = anisotropy;
    this._anisotropyRotation = anisotropyRotation;
    this._attenuationColor = attenuationColor;
    this._attenuationDistance = attenuationDistance;
    this._clearcoat = clearcoat;
    this._clearcoatRoughness = clearcoatRoughness;
    this._dispersion = dispersion;
    this._reflectivity = reflectivity;
    this._iridescence = iridescence;
    this._iridescenceIOR = iridescenceIOR;
    this._thickness = thickness;
    this._transmission = transmission;

    this._thicknessMapUrl = thicknessMapUrl;
    this._specularIntensityMapUrl = specularIntensityMapUrl;
    this._sheenColorMapUrl = sheenColorMapUrl;
    this._sheenRoughnessMapUrl = sheenRoughnessMapUrl;
    this._iridescenceThicknessMapUrl = iridescenceThicknessMapUrl;
    this._iridescenceMapUrl = iridescenceMapUrl;
    this._clearcoatRoughnessMapUrl = clearcoatRoughnessMapUrl;
    this._clearcoatNormalMapUrl = clearcoatNormalMapUrl;
    this._anisotropyMapUrl = anisotropyMapUrl;
  }

  public toDTO(): TextureDataDTO {
    return new TextureDataDTO(
      this._textureUrl,
      this._bumpMapUrl,
      this._glossMapUrl,
      this._normalMapUrl,
      this._roughness,
      this._metalness,
      this._color,
      this._bumpScale,
      this._uvMapScale,
      this._normalMapScale,
      this._colorInfo,
      this._sheen,
      this._sheenColor,
      this._specularIntensity,
      this._specularColor,
      this._defaultColorId,
      this._ior,

      this._anisotropy,
      this._anisotropyRotation,
      this._attenuationColor,
      this._attenuationDistance,
      this._clearcoat,
      this._clearcoatRoughness,
      this._dispersion,
      this._reflectivity,
      this._iridescence,
      this._iridescenceIOR,
      this._thickness,
      this._transmission,

      this._thicknessMapUrl,
      this._specularIntensityMapUrl,
      this._sheenColorMapUrl,
      this._sheenRoughnessMapUrl,
      this._iridescenceThicknessMapUrl,
      this._iridescenceMapUrl,
      this._clearcoatRoughnessMapUrl,
      this._clearcoatNormalMapUrl,
      this._anisotropyMapUrl,
    );
  }

  public get textureUrl(): string {
    return this._textureUrl;
  }

  public set textureUrl(value: string) {
    this._textureUrl = value;
  }

  public get bumpMapUrl(): string | undefined {
    return this._bumpMapUrl;
  }

  public set bumpMapUrl(value: string | undefined) {
    this._bumpMapUrl = value;
  }

  public get glossMapUrl(): string | undefined {
    return this._glossMapUrl;
  }

  public set glossMapUrl(value: string | undefined) {
    this._glossMapUrl = value;
  }

  public get normalMapUrl(): string | undefined {
    return this._normalMapUrl;
  }

  public set normalMapUrl(value: string | undefined) {
    this._normalMapUrl = value;
  }

  public get roughness(): number | undefined {
    return this._roughness;
  }

  public set roughness(value: number | undefined) {
    this._roughness = value;
  }

  public get metalness(): number | undefined {
    return this._metalness;
  }

  public set metalness(value: number | undefined) {
    this._metalness = value;
  }

  public get color(): string | undefined {
    return this._color;
  }

  public set color(value: string | undefined) {
    this._color = value;
  }

  public get bumpScale(): number | undefined {
    return this._bumpScale;
  }

  public set bumpScale(value: number | undefined) {
    this._bumpScale = value;
  }

  public get uvMapScale(): number | undefined {
    return this._uvMapScale;
  }

  public set uvMapScale(value: number | undefined) {
    this._uvMapScale = value;
  }

  public get normalMapScale(): number[] | undefined {
    return this._normalMapScale;
  }

  public set normalMapScale(value: number[] | undefined) {
    this._normalMapScale = value;
  }

  public get colorInfo(): string | undefined {
    return this._colorInfo;
  }

  public set colorInfo(value: string | undefined) {
    this._colorInfo = value;
  }

  public get sheen(): number | undefined {
    return this._sheen;
  }

  public set sheen(value: number | undefined) {
    this._sheen = value;
  }

  public get sheenColor(): string | undefined {
    return this._sheenColor;
  }

  public set sheenColor(value: string | undefined) {
    this._sheenColor = value;
  }

  public get specularIntensity(): number | undefined {
    return this._specularIntensity;
  }

  public set specularIntensity(value: number | undefined) {
    this._specularIntensity = value;
  }

  public get specularColor(): string | undefined {
    return this._specularColor;
  }

  public set specularColor(value: string | undefined) {
    this._specularColor = value;
  }

  public get defaultColorId(): string | undefined {
    return this._defaultColorId;
  }

  public set defaultColorId(value: string | undefined) {
    this._defaultColorId = value;
  }

  public get ior(): number | undefined {
    return this._ior;
  }

  public set ior(value: number | undefined) {
    this._ior = value;
  }

  public get anisotropy(): number | undefined {
    return this._anisotropy;
  }

  public set anisotropy(value: number | undefined) {
    this._anisotropy = value;
  }

  public get anisotropyRotation(): number | undefined {
    return this._anisotropyRotation;
  }

  public set anisotropyRotation(value: number | undefined) {
    this._anisotropyRotation = value;
  }

  public get attenuationColor(): string | undefined {
    return this._attenuationColor;
  }

  public set attenuationColor(value: string | undefined) {
    this._attenuationColor = value;
  }

  public get attenuationDistance(): number | undefined {
    return this._attenuationDistance;
  }

  public set attenuationDistance(value: number | undefined) {
    this._attenuationDistance = value;
  }

  public get clearcoat(): number | undefined {
    return this._clearcoat;
  }

  public set clearcoat(value: number | undefined) {
    this._clearcoat = value;
  }

  public get clearcoatRoughness(): number | undefined {
    return this._clearcoatRoughness;
  }

  public set clearcoatRoughness(value: number | undefined) {
    this._clearcoatRoughness = value;
  }

  public get dispersion(): number | undefined {
    return this._dispersion;
  }

  public set dispersion(value: number | undefined) {
    this._dispersion = value;
  }

  public get reflectivity(): number | undefined {
    return this._reflectivity;
  }

  public set reflectivity(value: number | undefined) {
    this._reflectivity = value;
  }

  public get iridescence(): number | undefined {
    return this._iridescence;
  }

  public set iridescence(value: number | undefined) {
    this._iridescence = value;
  }

  public get iridescenceIOR(): number | undefined {
    return this._iridescenceIOR;
  }

  public set iridescenceIOR(value: number | undefined) {
    this._iridescenceIOR = value;
  }

  public get thickness(): number | undefined {
    return this._thickness;
  }

  public set thickness(value: number | undefined) {
    this._thickness = value;
  }

  public get transmission(): number | undefined {
    return this._transmission;
  }

  public set transmission(value: number | undefined) {
    this._transmission = value;
  }

  public get thicknessMapUrl(): string | undefined {
    return this._thicknessMapUrl;
  }

  public set thicknessMapUrl(value: string | undefined) {
    this._thicknessMapUrl = value;
  }

  public get specularIntensityMapUrl(): string | undefined {
    return this._specularIntensityMapUrl;
  }

  public set specularIntensityMapUrl(value: string | undefined) {
    this._specularIntensityMapUrl = value;
  }

  public get sheenColorMapUrl(): string | undefined {
    return this._sheenColorMapUrl;
  }

  public set sheenColorMapUrl(value: string | undefined) {
    this._sheenColorMapUrl = value;
  }

  public get sheenRoughnessMapUrl(): string | undefined {
    return this._sheenRoughnessMapUrl;
  }

  public set sheenRoughnessMapUrl(value: string | undefined) {
    this._sheenRoughnessMapUrl = value;
  }

  public get iridescenceThicknessMapUrl(): string | undefined {
    return this._iridescenceThicknessMapUrl;
  }

  public set iridescenceThicknessMapUrl(value: string | undefined) {
    this._iridescenceThicknessMapUrl = value;
  }

  public get iridescenceMapUrl(): string | undefined {
    return this._iridescenceMapUrl;
  }

  public set iridescenceMapUrl(value: string | undefined) {
    this._iridescenceMapUrl = value;
  }

  public get clearcoatRoughnessMapUrl(): string | undefined {
    return this._clearcoatRoughnessMapUrl;
  }

  public set clearcoatRoughnessMapUrl(value: string | undefined) {
    this._clearcoatRoughnessMapUrl = value;
  }

  public get clearcoatNormalMapUrl(): string | undefined {
    return this._clearcoatNormalMapUrl;
  }

  public set clearcoatNormalMapUrl(value: string | undefined) {
    this._clearcoatNormalMapUrl = value;
  }

  public get anisotropyMapUrl(): string | undefined {
    return this._anisotropyMapUrl;
  }

  public set anisotropyMapUrl(value: string | undefined) {
    this._anisotropyMapUrl = value;
  }
}
